import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';
import { UnitConversionService } from '../../services/unit-conversion.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(
    public unitConversionService: UnitConversionService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {}

  async onUnitChanged(event: any) {
    const { value } = event;
    await this.unitConversionService.setUnit(value);
    this.analyticsService.trackEvent('DISTANCE_UNIT_CHANGED', value);
  }
}
